import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PRICE_LABEL = "14,90 €";
export const LOOKUP_KEY = "difesa_amm_2026_pdf";

export async function startCheckout() {
    try {
        const { data } = await axios.post(`${API}/payments/checkout`, {
            lookup_key: LOOKUP_KEY,
            origin_url: window.location.origin,
        });
        window.location.href = data.checkout_url;
    } catch (e) {
        toast.error("Impossibile avviare il pagamento. Riprova tra poco.");
        throw e;
    }
}

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
}
